import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listOrder, deleteOrder } from "../../actions/orderActions";
import Axios from "../../axios/axios";
import { dateFormat } from "../utils/Utils";

export default function NotDeliveryList() {
  const dispatch = useDispatch();

  // const orderList_ = useSelector((state) => state.orderList);
  // const { orders } = orderList_;

  const [orders, setOrders] = React.useState({ data: [] });
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    fetchOrders();
  }, [page]);

  const fetchOrders = async () => {
    setLoading(true);
    setOrders([]);

    try {
      const { data } = await Axios.post("/api/order/not-delivered", {
        page,
        isNotDelivered: true,
      });

      setOrders(data?.data || []);
      console.log("Orders data:", data?.data || []);
      setTotalPages(data?.pages || 1);
    } finally {
      setLoading(false);
    }
  };

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure")) {
      dispatch(deleteOrder(id));
      window.location.reload();
    }
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const search = (e) => {
    if (e.keyCode === 13) {
      let obj = {
        phone: parseInt(e.target.value),
        isNotDelivered: true,
      };
      dispatch(listOrder(obj));
    }
  };

  const editOrder = async (id) => {
    const data = await Axios.get(`/api/order/transaction/${id}`);

    if (data.data === 1) {
      window.location.href = `/order/edit/${id}`;
    } else {
      alert("Cant edit order!");
    }
  };

  const getDelivered = (order) => {
    let result = order?.orderItems?.some((data) => data.isDelivered === false);

    return result;
  };

  const getReturn = (order) => {
    let result = order?.orderItems?.some((data) => data.isReturn === false);

    return result;
  };

  const getTotalDays = (order) => {
    if (!order?.orderItems?.length) return 0;

    const startDates = order.orderItems.map((item) => new Date(item.startDate));

    const endDates = order.orderItems.map((item) => new Date(item.endDate));

    const minStart = new Date(Math.min(...startDates));
    const maxEnd = new Date(Math.max(...endDates));

    return Math.floor((maxEnd - minStart) / (1000 * 60 * 60 * 24)) + 1;
  };

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              {/* <div class="p-2"> */}
              {/* {' '} */}
              <h4 class="card-title">Incomplete Delivered List </h4>
              {/* </div> */}

              <div class="ml-auto p-2">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search Number here..."
                  onKeyDown={(e) => search(e)}
                />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style={{ width: "70px" }}>Sl No</th>
                    <th style={{ width: "180px" }}>Date</th>
                    <th>Order Id</th>
                    <th>Customer Name</th>
                    <th>Days</th>
                    <th>Delivered</th>
                    <th>Return</th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center" }}>
                        Loading...
                      </td>
                    </tr>
                  ) : orders.length > 0 ? (
                    orders.map((order, index) => (
                      <tr key={order._id}>
                        <td>{(page - 1) * 20 + index + 1}</td>
                        <td>{dateFormat(order?.createdAt)}</td>
                        <td>
                          <Link to={`/order/${order._id}`}>
                            ADC_{order?.orderId}
                          </Link>
                        </td>
                        <td>
                          <b>{order?.user?.name}</b>
                        </td>
                        <td>{getTotalDays(order)}</td>
                        <td>No</td>
                        <td>No</td>
                        <td>₹ {order?.orderAmount}</td>
                        <td>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => deleteHandler(order?._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center" }}>
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: "20px" }}>
              <button
                className="btn btn-secondary"
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
                disabled={page === 1}
              >
                Previous
              </button>

              <span style={{ margin: "0 10px" }}>
                Page {page} of {totalPages}
              </span>

              <button
                className="btn btn-primary"
                onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
